export default {"src":"/_next/static/media/emptyFilter.85cf053e.svg","height":202,"width":248,"blurWidth":0,"blurHeight":0};